import {HeadCustom} from "../../Header/HeadCustom";
import styled from "styled-components";
import screenSizes from "../../../utils/screenSizes";
import React from "react";
import {Link as LinkGatsby} from "gatsby"

export const Head = () => <HeadCustom
  title={`Liubomyr Ozhovych - Home page`}
  description={`Your personal boxing trainer - Boxing and fitness training will help you lose weight, get back in good shape and relieve stress. Let's do it together.`}
/>


export const HeaderContainer = styled.div `
  width: 100%;
  height: 100svh;
  
  min-height: 700px;
`

export const H3 = styled.h3 `
  color: var(--color-primary);
  font-family: var(--font-gothic);
  font-size: 96px;
  font-weight: 300;

  @media (max-width: ${screenSizes.mobile}) {
    font-size: 50px;
    font-weight: 100;
    text-align: center;
  }
`

export const Link = styled.a `
  cursor: pointer;
  color: var(--color-silver);
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  text-transform: uppercase;

  img {
    height: 20px;
    padding-left: 20px;
  }

  @media (max-width: ${screenSizes.mobile}) {
    font-size: 24px;
    font-weight: 100;
    text-align: center;

    img {
      padding-left: 10px;
    }
  }
`

export const LinkGatsbyCustom = styled(LinkGatsby) `
  color: var(--color-silver);
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  text-transform: uppercase;
  
  img {
    height: 20px;
    padding-left: 20px;
  }
  
  @media (max-width: ${screenSizes.mobile}) {
    font-size: 24px;
    font-weight: 100;
    text-align: center;
    
    img {
      padding-left: 10px;
    }
  }
`

export const ContactLinks = styled.div `
  display: flex;
  flex-direction: column;
  gap: 40px;
`

export const LinkContact = styled.a `
  display: flex;
  align-items: center;
  
  color: var(--color-silver-light);
  font-size: 24px;
  font-weight: 300;
  
  img {
    margin-right: 25px;
  }

  @media (max-width: ${screenSizes.mobile}) {
    font-size: 20px;
    
    img {
      height: 25px;
      margin-right: 15px;
    }
  }
`

export const LinkGatsbyContact = styled(LinkGatsby) `
  display: flex;
  align-items: center;
  
  color: var(--color-silver-light);
  font-size: 24px;
  font-weight: 300;
  
  img {
    margin-right: 25px;
  }

  @media (max-width: ${screenSizes.mobile}) {
    font-size: 20px;
    
    img {
      height: 25px;
      margin-right: 15px;
    }
  }
`

export const Socials =  styled.div `
  display: flex;
  flex-direction: row;
  
  gap: 43px;
  
  >div {
    width: 50px;
    
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
